import {useEffect, useRef} from 'react';
import styled from "styled-components";

// assigns the current component instance's DOM reference to the ref variable with the help of the useRef Hook.
export function TagListFunctional(props) {
    const ref = useRef(null);
    const {onClickOutside} = props;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside && onClickOutside();
            }
        };
        // After that, it registers a click handler inside the useEffect Hook to the entire document du detect global click events.
        document.addEventListener('click', handleClickOutside, true);
        // we return a function with cleanup code which mean we can unregister our global click event listener
        // when the component is unmounted
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    if (!props.show)
        return null;

    return (
        <Box ref={ref} className='info-box'>
            {props.component}
        </Box>);
}

const Box = styled.div`
  position: absolute;
  z-index: 2;
`